export const loginAPI  = 'https://pharmeasyclone.onrender.com/user/login'
export const signupAPI  = 'https://pharmeasyclone.onrender.com/user/signup'
export const checkLoggedInAPI  = 'https://pharmeasyclone.onrender.com/checkLoggedIn/'
export const GitAuthURL  = 'https://pharmeasyclone.onrender.com/user/githubsignin'